// Language translations for the application

export const translations = {
  en: {
    // Header
    home: "Home",
    pricing: "Pricing",
    contact: "Contact",
    
    // Hero section
    removeBackground: "Remove Image Backgrounds",
    backgroundsInstantly: "For Perfect White Wallpapers",
    heroDescription: "Professional-quality background removal powered by AI. Create stunning white wallpapers and checkered wallpapers with 100% free, unlimited usage. Perfect for product photos, portraits, and design work.",
    getStarted: "Get Started",
    viewSamples: "View Samples",
    
    // Upload section
    uploadYourImage: "Upload Your Image",
    dragAndDrop: "Drag & drop your image or click to browse",
    dropHere: "Drop your image here",
    dragHere: "Drag & drop your image here",
    or: "or",
    browseFiles: "Browse Files",
    supportsFormats: "Supports JPG, PNG, WEBP",
    processing: "Processing your image...",
    tryAgain: "Try Again",
    
    // Sample images
    tryWithSample: "Or try with a sample:",
    useThisImage: "Use this image",
    
    // Features
    fast: "Fast",
    fastDescription: "Results in seconds, no waiting",
    free: "Free",
    freeDescription: "No cost, no hidden fees",
    unlimited: "Unlimited",
    unlimitedDescription: "No usage restrictions",
    
    // How it works
    howItWorks: "How It Works",
    howItWorksDescription: "Remove backgrounds in three simple steps",
    step1Title: "Upload Your Image",
    step1Description: "Drag and drop your image or select from your device. We support JPG, PNG, and WEBP formats.",
    step2Title: "AI Processing",
    step2Description: "Our advanced AI technology automatically detects and removes the background from your image.",
    step3Title: "Download Result",
    step3Description: "Download your image with the background removed. Ready to use for your projects.",
    
    // Results page
    yourImages: "Your Images",
    backToHome: "Back to Home",
    
    // Footer
    product: "Product",
    features: "Features",
    api: "API",
    integrations: "Integrations",
    resources: "Resources",
    documentation: "Documentation",
    tutorials: "Tutorials",
    blog: "Blog",
    support: "Support",
    company: "Company",
    about: "About",
    privacy: "Privacy",
    terms: "Terms",
    allRightsReserved: "All rights reserved.",
    footerDescription: "BG Swap is a free, unlimited AI-powered background removal tool that delivers professional results instantly. Create perfect white wallpapers and checkered wallpapers with no sign-up required, no usage limits, and no watermarks.",
    
    // Pricing tooltip
    comingSoon: "Coming Soon!",
    pricingMessage: "BG Swap is currently 100% free! Take advantage of unlimited usage now before we introduce our premium plans.",
    
    // Wallpaper use cases
    popularUses: "Popular Wallpaper Uses",
    popularUsesDescription: "Create stunning wallpapers by removing backgrounds from your images",
    whiteWallpaper: "White Wallpaper",
    whiteWallpaperDescription: "Create clean, minimalist white wallpapers by removing backgrounds from your subjects. Perfect for product photography and modern designs.",
    checkeredWallpaper: "Checkered Wallpaper",
    checkeredWallpaperDescription: "Place your subjects on trendy checkered wallpaper backgrounds for eye-catching contrast and visual interest.",
    customWallpaper: "Custom Wallpaper",
    customWallpaperDescription: "Design unique wallpapers by combining multiple background-removed images on any backdrop of your choice.",
  },
  es: {
    // Header
    home: "Inicio",
    pricing: "Precios",
    contact: "Contacto",
    
    // Hero section
    removeBackground: "Elimina Fondos de Imágenes",
    backgroundsInstantly: "Para Fondos Blancos Perfectos",
    heroDescription: "Eliminación de fondos de calidad profesional impulsada por IA. Crea impresionantes fondos blancos y fondos a cuadros con uso 100% gratuito e ilimitado. Perfecto para fotos de productos, retratos y diseño.",
    getStarted: "Comenzar",
    viewSamples: "Ver Ejemplos",
    
    // Upload section
    uploadYourImage: "Sube tu Imagen",
    dragAndDrop: "Arrastra y suelta tu imagen o haz clic para explorar",
    dropHere: "Suelta tu imagen aquí",
    dragHere: "Arrastra y suelta tu imagen aquí",
    or: "o",
    browseFiles: "Explorar Archivos",
    supportsFormats: "Compatible con JPG, PNG, WEBP",
    processing: "Procesando tu imagen...",
    tryAgain: "Intentar de Nuevo",
    
    // Sample images
    tryWithSample: "O prueba con un ejemplo:",
    useThisImage: "Usar esta imagen",
    
    // Features
    fast: "Rápido",
    fastDescription: "Resultados en segundos, sin esperas",
    free: "Gratis",
    freeDescription: "Sin costo, sin tarifas ocultas",
    unlimited: "Ilimitado",
    unlimitedDescription: "Sin restricciones de uso",
    
    // How it works
    howItWorks: "Cómo Funciona",
    howItWorksDescription: "Elimina fondos en tres simples pasos",
    step1Title: "Sube tu Imagen",
    step1Description: "Arrastra y suelta tu imagen o selecciona desde tu dispositivo. Soportamos formatos JPG, PNG y WEBP.",
    step2Title: "Procesamiento IA",
    step2Description: "Nuestra avanzada tecnología de IA detecta y elimina automáticamente el fondo de tu imagen.",
    step3Title: "Descarga el Resultado",
    step3Description: "Descarga tu imagen con el fondo eliminado. Lista para usar en tus proyectos.",
    
    // Results page
    yourImages: "Tus Imágenes",
    backToHome: "Volver al Inicio",
    
    // Footer
    product: "Producto",
    features: "Características",
    api: "API",
    integrations: "Integraciones",
    resources: "Recursos",
    documentation: "Documentación",
    tutorials: "Tutoriales",
    blog: "Blog",
    support: "Soporte",
    company: "Empresa",
    about: "Acerca de",
    privacy: "Privacidad",
    terms: "Términos",
    allRightsReserved: "Todos los derechos reservados.",
    footerDescription: "BG Swap es una herramienta gratuita e ilimitada de eliminación de fondos impulsada por IA que ofrece resultados profesionales al instante. Crea fondos blancos y fondos a cuadros perfectos sin registro, sin límites de uso y sin marcas de agua.",
    
    // Pricing tooltip
    comingSoon: "¡Próximamente!",
    pricingMessage: "¡BG Swap es actualmente 100% gratis! Aprovecha el uso ilimitado ahora antes de que introduzcamos nuestros planes premium.",
    
    // Wallpaper use cases
    popularUses: "Usos Populares para Fondos",
    popularUsesDescription: "Crea impresionantes fondos de pantalla eliminando los fondos de tus imágenes",
    whiteWallpaper: "Fondo Blanco",
    whiteWallpaperDescription: "Crea fondos blancos limpios y minimalistas eliminando los fondos de tus sujetos. Perfecto para fotografía de productos y diseños modernos.",
    checkeredWallpaper: "Fondo a Cuadros",
    checkeredWallpaperDescription: "Coloca tus sujetos sobre fondos a cuadros de moda para un contraste llamativo e interés visual.",
    customWallpaper: "Fondo Personalizado",
    customWallpaperDescription: "Diseña fondos únicos combinando múltiples imágenes sin fondo en cualquier escenario de tu elección.",
  }
};

export type Language = keyof typeof translations;
export type TranslationKey = keyof typeof translations.en; 